import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/* NgRx */
import { StoreModule } from '@ngrx/store';
import { reducer } from './state/tracking.reducer';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EffectsModule } from '@ngrx/effects';
import { TrackingEffects } from './state/tracking.effects';

import { TrackingShellComponent } from './containers/tracking-shell/tracking-shell.component';
import { TrackingListComponent } from './components/tracking-list/tracking-list.component';
import { TrackingEditShellComponent } from './containers/tracking-edit-shell/tracking-edit-shell.component';
import { TrackingEditComponent } from './components/tracking-edit/tracking-edit.component';


@NgModule({
  declarations: [
    TrackingShellComponent,
    TrackingEditShellComponent,
    TrackingListComponent,
    TrackingEditComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    StoreModule.forFeature('trackings', reducer),
    EffectsModule.forFeature([TrackingEffects])
  ],
  exports: [
    TrackingListComponent,
    TrackingEditComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class TrackingModule {
  constructor(
  ) {}
}
